import { useState } from 'react';
import { MASKS, type MaskName } from './masks';
import { TextField, type TextFieldProps } from './TextField';

export type MaskedFieldProps = Omit<TextFieldProps, 'value' | 'onChange' | 'defaultValue'> & {
  mask: MaskName;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
};

/** Campo com máscara (hoje: CNPJ). Controlado (`value`) ou não (`defaultValue`). */
export function MaskedField({ mask, value, defaultValue = '', onChange, ...props }: MaskedFieldProps) {
  const m = MASKS[mask];
  const [inner, setInner] = useState(m.fn(defaultValue));
  const current = value ?? inner;
  return (
    <TextField
      inputMode="numeric"
      maxLength={m.maxLength}
      placeholder={m.placeholder}
      {...props}
      value={current}
      onChange={(e) => {
        const next = m.fn(e.target.value);
        if (value === undefined) setInner(next);
        onChange?.(next);
      }}
    />
  );
}
